Object.defineProperty(exports, '__esModule', {
  value: true
});

/**
 * https://www.figma.com/file/GGnKd4XwuMFLdjlULg2vaF/Hubcapp-Portal-v2?node-id=2322%3A55
 */
var areaAvatarColors = ["#FE615A", "#62C5C5", "#50A097", "#FEA65F", "#3E6C73", "#6AD49B", "#458DBB", "#EE6E8D", "#C5B7BE", "#51C5DE", "#315B70", "#D7E465", "#5A5ABB", "#344373", "#9FDCD5"];
exports.areaAvatarColors = areaAvatarColors;